<template>
  <el-upload
    class="upload-demo"
    :action="this.uploadURL"
    name="file"
    :on-success="handleFilePreview"
    :before-upload="beforeFileHandlePreview"
    :file-list="fileList"
    :list-type="listType"
    :on-remove="removeFileHandlePreview"
    style="text-align:left"
    :disabled="disabled"
  >
    <el-button :class="{ disabled: disabled }" size="small" type="primary">{{ txt }}</el-button>
    <div slot="file" slot-scope="{ file }" class="file-list">
      {{ file.name }}
      <div class="file-download" @click="handleDownload(file)">下载</div>
    </div>
  </el-upload>
</template>
<script>
import { DownLoadUrl } from '../utils/tool';
export default {
  props: {
    inputValue: {
      type: String,
    },
    listType: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    txt: {
      type: String,
      default: '点击上传',
    },
    list: {
      type: Array,
      // default: []
    },
  },
  data() {
    return {
      fileList: [],
    };
  },
  created() {
    this.fileList = this.list;
  },
  watch: {
    list() {
      this.fileList = this.list;
    },
  },
  methods: {
    handleDownload(file) {
      if (file.url) {
        const url = this.imgUrl+file.url;
        DownLoadUrl(url);
      }
    },
    //上传文件
    handleFilePreview(response, file, fileList) {
      if (response.code == 0) {
        this.fileList = fileList;
        this.$emit('successUp', this.inputValue, this.fileList);
      }
      // this.fileList = [
      //   {
      //     name: file.name,
      //     url: this.imgUrl + response.data.store_result,
      //     store_result: response.data.store_result
      //   }
      // ];
      else this.$message.warning(`上传失败！！！`);
    },
    beforeFileHandlePreview(file) {
      // if (this.fileList.length > 0) {
      //   this.$message.warning(`当前限制上传 1 个文件`);
      //   return false;
      // }
      // let type = false;
      // if (file.type === "video/mp4") {
      //   type = true;
      // }
      // if (!type) {
      //   this.$message.error("上传视频只能是MP4格式!");
      // }
      // return type;
    },
    removeFileHandlePreview(file, fileList) {
      this.fileList = fileList;
      this.$emit('removeUp', this.inputValue, this.fileList);
      // this.$confirm("确定删除文件吗?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      //   center: true
      // })
      //   .then(() => {
      //     this.fileList = [];
      //     this.$message({
      //       type: "success",
      //       message: "删除成功!"
      //     });
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "已取消删除"
      //     });
      //   });
    },
  },
};
</script>
<style lang="scss" scoped>
.upload-demo {
  margin-top: 10px;
  /deep/.el-upload {
    /deep/.el-button {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(66, 141, 255, 1);
      border-radius: 18px;
      padding: 10px 25px;
    }
    /deep/.disabled {
      background: #999;
      border-color: #999;
    }
  }
  .file-list {
    display: flex;
    align-items: center;
    .file-download {
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translate(0, -50%);
      cursor: pointer;
      border: 1px solid #333;
      padding: 2px 4px 1px 4px;
      border-radius: 3px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #428dff;
        border: 1px solid #428dff;
      }
    }
  }
}
</style>
